import React from 'react';
import { InstantSearch, Configure } from 'react-instantsearch';

import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { PagesResults } from '../../commons/helpers';

const SearchPagesContent = ({
  facetFilters,
  indexName,
  page,
  query,
  searchState,
  searchStateQuery,
  toggleIsSearchOpen,
  updateSearchPage,
}) => (
  <div className="w-full">
    <InstantSearch
      searchClient={searchClient}
      /* TODO: CON-7887: (Codemod generated): `searchState` is no longer supported. This is now handled via an `onStateChange` callback.
      See https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/react-hooks/#replace-searchstate-with-initialuistate */
      searchState={searchState}
      indexName={indexName}
    >
      <Configure
        query={searchStateQuery}
        hitsPerPage={9}
        facetFilters={facetFilters}
        numericFilters={['is_active=1', 'show_in_search=1', 'fk_store_id=1']}
      />

      <PagesResults
        toggleSearchOpen={toggleIsSearchOpen}
        onLoadMore={updateSearchPage}
        query={query}
        currentPage={page}
        variant="advanced-search"
      />
    </InstantSearch>
  </div>
);

export default SearchPagesContent;
